<mat-accordion>
  <mat-expansion-panel *ngFor="let negociacao of negociacoes">
    <mat-expansion-panel-header expandedHeight="150px" collapsedHeight="150px">
      <table class="table-job-listing table-responsive">
        <tr role="button">
          <td class="table-job-listing-main">
            <article class="company-minimal">
              <figure class="company-minimal-figure">
                <img [src]="negociacao.imagemProduto" class="company-minimal-image" alt="" width="45" height="45" />
              </figure>
              <div class="company-minimal-main">
                <h5 class="company-minimal-title">
                  <a role="button">{{negociacao.nomeProduto.length > 88 ? negociacao.nomeProduto.substring(0, 85)+
                    '...': negociacao.nomeProduto}}</a>
                  <span class="badge badge-secondary text-lowercase rounded ml-2">{{negociacao.condicao_produto}}</span>
                </h5>
                <p><span class="icon icon-1 text-primary mdi mdi-map-marker"></span>{{negociacao.cidade}},
                  {{negociacao.estado}}</p>
                <p style="margin-bottom: 0;"><span class="text-primary">{{negociacao.uid}}</span></p>
                <p class="negotiation-minimal-id" *ngIf="negociacao.composto">
                  <img src="assets/favicon.ico" [width]="16" class="company-minimal-image" alt="" width="45" height="45"
                    style="margin-right: 5px;" />{{"negociacao" | transloco}}:
                  <span class="text-primary">#{{negociacao.composto}}</span>
                </p>
              </div>
            </article>
          </td>
          <td class="table-job-listing-date" style="text-align:left;">
            <span>{{'quantidade' | transloco: {quantidade: negociacao.quantidade} }}</span>
          </td>
          <td class="table-job-listing-date" style="width: 250px;text-align: left;">
            <span class="icon icon-sm text-primary mdi mdi-cash-multiple"></span>
            <span> {{'melhor_lance' | transloco}} {{negociacao.melhor_lance ? (negociacao.melhor_lance | currency:
              "BRL":'symbol') :
              ('melhor_lance_nenhum' | transloco)}}</span>
          </td>
          <td class="table-job-listing-badge">
            <a role="button"
              [ngClass]="statusStyles[negociacao.venda?.pagamento?.status] || 'badge'">{{statusTile[negociacao?.venda?.pagamento?.status] | transloco}}</a>
          </td>
        </tr>
      </table>
    </mat-expansion-panel-header>
    <hr>
    <!-- Conteúdo do painel -->
    <div *ngIf="!negociacao?.uid_venda; else sale" class="informations m-2">
      <!-- Detalhes da negociação -->
      <span>{{'negociacao_falha' | transloco}}</span> <a class="text-primary see-more"
        (click)="onDetalhesNegociacao(negociacao)">{{'ver_negociacao' | transloco}}</a>
    </div>
    <ng-template #sale>
      <div *ngIf="negociacao?.rastreios ; else retira">
        <div *ngFor="let tracking of negociacao.rastreios;">
          <div class="line-letter"></div>
          <app-stepper [currentStep]="fetchCurrentStep(negociacao?.venda, tracking)" [sale_id]="negociacao?.uid_venda"
            (openModal)="openModal($event)" [steps]="fetchSteps(negociacao?.venda, tracking)"></app-stepper>
          <br>
          <hr *ngIf="tracking">
          <div class="accordion-content">
            <div class="delivery-address mt-2">
              <h3>{{'endereco_entrega' | transloco}}</h3>
              <p>{{negociacao?.venda?.comprador?.nome}}</p>
              <p>(+55) {{negociacao?.venda?.comprador?.telefone}}</p>
              <p>{{negociacao?.venda?.comprador?.endereco}}</p>
              <a class="text-primary see-more" (click)="onDetalhesCompra(negociacao?.uid_venda)">Detalhes da Compra</a>
              <p>
                <a class="text-primary see-more" (click)="openEvaluateProductDialog(negociacao?.ean)">Avaliar Produto</a>
              </p>
            </div>

            <div class="delivery-status mt-2">
              <h3>{{'rastreamento' | transloco}}</h3>
              <ul *ngIf="tracking" class="timeline">
                <div *ngFor="let item of tracking;  let i = index">
                  <li [ngClass]="'status status-'+statusEventsTile[item.descricao] + (i == 0 ?'-now':'')">
                    <span class="time">{{ item?.dtHrCriado | date:'dd\'/\'MM\'/\'yyyy \'às\'
                      HH\':\'mm'
                      }}</span>
                    <span class="status" [ngStyle]="{'color': getStatusColor(statusEventsTile[item.descricao])}">
                      {{titleCase[statusEventsTile[item?.descricao]] }}
                    </span>
                  </li>
                  <li *ngIf="!item?.unidadeDestino; else withDestination">
                    <span *ngIf="item?.detalhe; else elseBlock">{{ item?.descricao }}
                      <br>{{ item?.unidade?.endereco?.cidade }} - {{ item?.unidade?.endereco?.uf }} <br> {{
                      item?.detalhe
                      }}
                    </span>
                    <ng-template #elseBlock>
                      <span>{{ item?.descricao }}
                        <br>{{ item?.unidade?.endereco?.cidade }} - {{ item?.unidade?.endereco?.uf }} <br> {{
                        item?.detalhe
                        }}
                      </span>
                    </ng-template>
                  </li>
                  <ng-template #withDestination>
                    <li>
                      <span>{{ item?.descricao }}
                        <br>de {{item?.unidade?.tipo}}, {{item?.unidade?.endereco?.cidade}} -
                        {{item?.unidade?.endereco?.uf}}
                        <br>para {{item?.unidadeDestino?.tipo}}, {{item?.unidadeDestino?.endereco?.cidade}} -
                        {{item?.unidadeDestino?.endereco?.uf}}
                      </span>
                    </li>
                  </ng-template>
                </div>
              </ul>
            </div>
            <div class="delivery-id mt-2">
              <div>
                <h3>{{negociacao?.venda?.envio?.status}}</h3>
                <h5 *ngIf="tracking?.CodigoObjeto">{{'codigo_rastreio' | transloco}}: {{tracking?.CodigoObjeto}}</h5>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <ng-template #retira>
        <div class="line-letter"></div>
        <app-stepper [currentStep]="fetchCureentStepReadyForPickup(negociacao?.venda)" [sale_id]="negociacao?.uid_venda"
          (openModal)="openModal($event)" [steps]="fetchStepsReadyForPickUp(negociacao?.venda)"></app-stepper>
        <br>
        <hr>
      </ng-template>
      <div class="accordion-footer">
        <div
          *ngIf="negociacao?.venda?.envio?.status == 'Retirada no local' && negociacao?.venda?.pagamento?.status == 'pagamento_aprovado' && negociacao?.venda?.retirada?.pronto"
          class=" mb-4 mt-4">
          <p>
            {{'pedido_disponibilizado_retirada' | transloco}}
            <span>
              {{'a_partir_de' | transloco}} {{(negociacao?.venda?.retirada?.pronto | date :'dd \'de\' MMMM \'de\' yyyy \'ás\'
              HH\':\'mm')}}
            </span>
          </p>
          <div *ngIf="negociacao?.venda?.retirada?.pronto && !negociacao?.venda?.retirada?.confirmado; else confirmed"
            class="d-flex lign-items-center">
            <p>
              {{negociacao?.venda?.comprador?.nome}}, você confirma que está retirando o pedido?
              <button type="button" (click)="confirmWithdrawOrder(negociacao.uid_venda)" class="btn btn-link">{{'sim' |
                transloco}}</button>
            </p>
          </div>
          <ng-template #confirmed>
            <div class="d-flex lign-items-center">
              <p>
                {{negociacao?.venda?.comprador?.nome}}, {{'confirmou_retirada_pedido' | transloco}}
                <br>
                <br>
                Retirada confirmada em: {{(negociacao?.venda?.retirada?.confirmado| date :'dd \'de\' MMMM \'de\'
                yyyy\' ás\' HH\':\'mm')}}
                <img src="assets/images/match.png" class="company-minimal-image" alt="match" width="20" height="20" />
                <br *ngIf="negociacao?.venda?.retirada?.retirado != null">
                <br *ngIf="negociacao?.venda?.retirada?.retirado != null">
                {{negociacao?.venda?.retirada?.retirado != null ? 'Vendedor confirmou a sua retirada em: ' +
                (negociacao?.venda?.retirada?.retirado| date :'dd \'de\' MMMM \'de\' yyyy\' ás\' HH\':\'mm') : ''}}
                <img *ngIf="negociacao?.venda?.retirada?.retirado != null" src="assets/images/match.png"
                  class="company-minimal-image" alt="match" width="20" height="20" />
              </p>

            </div>
          </ng-template>
        </div>
        <table class="table">
          <tr>
            <td>{{'total_produtos' | transloco}}</td>
            <td> <strong>{{negociacao?.venda?.valor_produtos | currency: "BRL":'symbol'}}</strong></td>
          </tr>
          <tr>
            <td>{{'taxa_frete' | transloco}}</td>
            <td> <strong>{{negociacao?.venda?.valor_frete | currency: "BRL":'symbol'}}</strong></td>
          </tr>
          <tr>
            <td>{{'total_pedido' | transloco}}</td>
            <td><strong class="text-blue">{{negociacao?.venda?.valor_total | currency: "BRL":'symbol'}}</strong></td>
          </tr>
          <tr>
            <td>{{'metodo_pagamento' | transloco}}</td>
            <td>{{negociacao?.venda?.meio_pagamento}} - {{negociacao?.venda?.parcelamento}}</td>
          </tr>
        </table>
        <div *ngIf="negociacao?.venda?.rating">
          <br>
          <h3>{{ 'avaliacao_pedido' | transloco }}</h3>
          <div class="star-rating">
            <mat-icon *ngFor="let star of [1, 2, 3, 4, 5]" [class.filled]="star <= negociacao?.venda?.rating">
              star
            </mat-icon>
            <span>{{ getRatingDescription(negociacao?.venda?.rating) | transloco }}</span>
          </div>
          <br>
          <span>{{'avaliado_em' | transloco}}: {{negociacao?.venda?.reviewed_at | date:'dd\'/\'MM\'/\'yyyy \'às\'
            HH\':\'mm'}}</span>
          <div class="review-text">
            <p>{{ negociacao?.venda?.review }}</p>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
